module.exports = require('./components/router');
